import Header from './components/Header';
import Footer from './components/Footer';
import About from './pages/About';
import NotFound from './pages/NotFound';
import AccessDenied from './pages/AccessDenied';
import {Route,Routes,BrowserRouter as Router,useNavigate, Navigate} from 'react-router-dom';
import {useState,useEffect} from 'react'
import api from './api/login';
import LoginUI from './pages/LoginUI';
import LogOutUI from './pages/LogOutUI';
import ProtectedRoute from './ProtectedRoute';
import Spinner from 'react-bootstrap/Spinner';



import MoreOptions from './pages/MoreOptions';


import NavAdmin from './components/NavAdmin';
import NavStudent from './components/NavStudent';
import UserNav from './components/UserNav';
import HomeAdmin from './pages/HomeAdmin';
import HomeStudent from './pages/HomeStudent';

import MasterCourse from './pages/MasterCourse';

import MarksEntryCourses from './pages/MarksEntryCourses';
import MarksEntryBatches from './pages/MarksEntryBatches';
import MarksEntryForm from './pages/MarksEntryForm';

import GradeEntryCourses from './pages/GradeEntryCourses';
import GradeEntryBatches from './pages/GradeEntryBatches';
import GradeEntryForm from './pages/GradeEntryForm';

import ChangePassword from './pages/ChangePassword';
import SubmittedGradeCourses from './pages/SubmittedGradeCourses';
import SubmittedGradeBatches from './pages/SubmittedGradeBatches';
import SubmittedGradeForm from './pages/SubmittedGradeForm';
import ResultDeclarationBatches from './pages/ResultDeclarationBatches';
import ConvocationSwitches from './pages/ConvocationSwitches';
import ResultDeclarationForm from './pages/ResultDeclarationForm';
import GenerateConvoCertificates from './pages/GenerateConvoCertificates';

import EditConvoCertificateDetails from './pages/EditConvoCertificateDetails';

import FormfillupBatches from './pages/FormfillupBatches';

import EditResult from './pages/EditResult';
import ViewMyResult from './studentpages/ViewMyResult';
import DoFormFillup from './studentpages/DoFormFillup';
import FormFillupDetails from './pages/FormFillupDetails';
import SubmittedFormFillupReport from './pages/SubmittedFormFillupReport';
import SubmittedNewRegistrationAndFormFillupReport from './pages/SubmittedNewRegistrationAndFormFillupReport';
import AllowResubmission from './pages/AllowResubmission';
import AttendanceSheet from './pages/AttendanceSheet';
import DownloadMyAdmitCard from './studentpages/DownloadMyAdmitCard';
import StudentTranscript from './pages/StudentTranscript';

import ApplyConvocation from './studentpages/ApplyConvocaation';

import NewStudent from './studentpages/NewStudent';
import NavNewStudent from './studentcomponents/NavNewStudent';


function App() {    
  const [isAuthenticated,setIsAuthenticated]=useState(false); 
  const [isAppLoaded,setIsAppLoaded]=useState(true); 
  const [refreshFailed,setRefreshFailed]=useState(true);
  const [accessToken,setAccessToken]=useState(''); 
  const [loginType,setLoginType]=useState('');
  const [allowedPages,setAllowedPages]=useState([]);
  const [fullName,setFullName]=useState('');
  const [appUserName,setAppUserName]=useState('');

const sessions = [  
  "2026-MAY",
  "2025-DECEMBER",
  "2025-MAY",
  "2024-DECEMBER",
  "2024-MAY",
  "2023-DECEMBER",
  "2023-MAY",
  "2022-DECEMBER",
  "2022-MAY",
  "2021-DECEMBER",
  "2021-MAY",
  "2020-DECEMBER",
  "2020-MAY",
  "2019-DECEMBER",
  "2019-MAY"
];
const examSession= "2026-MAY";

      const levels=["UG","PG","PHD","PGDCA"];
      const semesters=[1,2,3,4,5,6,7,8,9,10];
      
      const [marksEntrySession,setMarksEntrySession]=useState('');
   const [gradeEntrySession,setGradeEntrySession]=useState('');
    const [resultEntrySession,setResultEntrySession]=useState('');
      const [submittedGradeSession,setSubmittedGradeSession]=useState('');

        const [marksEntryLevel,setMarksEntryLevel]=useState('');
          const [marksEntrySem,setMarksEntrySem]=useState('');
              const [marksEntrySub,setMarksEntrySub]=useState('');

               const [gradeEntryLevel,setGradeEntryLevel]=useState('');
          const [gradeEntrySem,setGradeEntrySem]=useState('');
              const [gradeEntrySub,setGradeEntrySub]=useState('');

               const [submittedGradeLevel,setSubmittedGradeLevel]=useState('');
          const [submittedGradeSem,setSubmittedGradeSem]=useState('');
              const [submittedGradeSub,setSubmittedGradeSub]=useState('');



  useEffect(()=>{
    const fetchAT=async ()=>{
          try{
            const config = { withCredentials: true };
            const x=await api.get('/getAccessToken',config); 
            const nat=x['data']['accessToken'];
            const ufn=x['data']['userFullName'];
            const un=x['data']['userName'];
            const lt=x['data']['loginType'];
            setAccessToken(nat);   
            setAllowedPages(x['data']['allowedPages']); 
            setFullName(x['data']['userFullName']);
            setAppUserName(x['data']['userName']);
            setLoginType(lt);     
            setIsAuthenticated(true);   
            setRefreshFailed(false); 
            }
            catch(err)
            {
              //alert(err);
              setAccessToken('');   
              setLoginType('');   
              setIsAuthenticated(false);  
              setRefreshFailed(true);              
            }
            finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }
    fetchAT();
  },[refreshFailed]);
  return (   
    <Router>
      <div className="App">
      {<Header></Header>}
        { (isAppLoaded)&&!refreshFailed &&(loginType.toLowerCase()==="admin")&& <NavAdmin
          />}
         { (isAppLoaded)&&!refreshFailed &&(loginType.toLowerCase()==="student")&& <NavStudent
          />} 
            { (isAppLoaded)&&!refreshFailed &&(loginType.toLowerCase()==="newstudent")&& <NavNewStudent
          />} 
          
          { (isAppLoaded)&&refreshFailed&& <UserNav
          />
          }

        { (isAppLoaded) &&!refreshFailed &&(loginType.toLowerCase()==="admin")&&
          <>
          <Routes>
             <Route element={<ProtectedRoute isAuthenticated={isAuthenticated}/>}>
                <Route  path='/' element={<HomeAdmin                        
                          allowedPages={allowedPages}
                          fullName={fullName}
                          />}>            
                </Route>
                <Route  path='/changepassword' element={<ChangePassword                        
                           accessToken={accessToken} 
                           setAccessToken={setAccessToken}
                           setRefreshFailed={setRefreshFailed}
                           appUserName={appUserName}
                          />}>            
                </Route>

                <Route path='/masterCourse' element={<MasterCourse
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                </Route>    
                <Route path='/marksEntryCourses' element={<MarksEntryCourses
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}

                          marksEntrySession={marksEntrySession}
                          setMarksEntrySession={setMarksEntrySession}
                          sessions={sessions}
                          
                          levels={levels}
                          semesters={semesters}
                          marksEntryLevel={marksEntryLevel}
                          setMarksEntryLevel={setMarksEntryLevel}
                          marksEntrySem={marksEntrySem}
                          setMarksEntrySem={setMarksEntrySem}
                          marksEntrySub={marksEntrySub}
                          setMarksEntrySub={setMarksEntrySub}

                          />}> 
                </Route>
                <Route path='/marksentrybatches/:courseCode/:session' element={<MarksEntryBatches
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                </Route> 
                <Route path='/marksentryform/:batch/:session/:courseCode' element={<MarksEntryForm
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                </Route>     
                <Route path='/gradeEntryCourses' element={<GradeEntryCourses
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}

                           marksEntrySession={gradeEntrySession}
                          setMarksEntrySession={setGradeEntrySession}
                          sessions={sessions}
                          
                          levels={levels}
                          semesters={semesters}
                          marksEntryLevel={gradeEntryLevel}
                          setMarksEntryLevel={setGradeEntryLevel}
                          marksEntrySem={gradeEntrySem}
                          setMarksEntrySem={setGradeEntrySem}
                          marksEntrySub={gradeEntrySub}
                          setMarksEntrySub={setGradeEntrySub}


                          />}> 
                </Route>
                <Route path='/gradeentrybatches/:courseCode/:session' element={<GradeEntryBatches
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                </Route> 
                <Route path='/gradeentryform/:batch/:session/:courseCode' element={<GradeEntryForm
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                </Route> 
                <Route path='/submittedGrades' element={<SubmittedGradeCourses
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}

                          marksEntrySession={submittedGradeSession}
                          setMarksEntrySession={setSubmittedGradeSession}
                          sessions={sessions}
                          
                          levels={levels}
                          semesters={semesters}
                          marksEntryLevel={submittedGradeLevel}
                          setMarksEntryLevel={setSubmittedGradeLevel}
                          marksEntrySem={submittedGradeSem}
                          setMarksEntrySem={setSubmittedGradeSem}
                          marksEntrySub={submittedGradeSub}
                          setMarksEntrySub={setSubmittedGradeSub}
                          />}> 
                </Route>
                <Route path='/submittedgradebatches/:courseCode/:session' element={<SubmittedGradeBatches
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                </Route>
                <Route path='/submittedgradeform/:batch/:session/:courseCode' element={<SubmittedGradeForm
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                </Route> 
                <Route path='/editresult' element={<EditResult
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                 </Route> 
                 <Route path='/resultdeclarationbatches' element={<ResultDeclarationBatches
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}

                           resultEntrySession={resultEntrySession}
                          setResultEntrySession={setResultEntrySession}
                          sessions={sessions}
                          />}> 
                 </Route> 
               <Route path='/convoswitches' element={<ConvocationSwitches
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}

                           resultEntrySession={resultEntrySession}
                          setResultEntrySession={setResultEntrySession}
                          sessions={sessions}
                          />}> 
                 </Route> 
                 

                 <Route path="/resultdeclarationform/:batch/:session/:semester" element={<ResultDeclarationForm
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                />} /> 


                <Route path='/generatecertificates' element={<GenerateConvoCertificates
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                 </Route> 

                 <Route path='/editcertificates' element={<EditConvoCertificateDetails
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                 </Route> 
                 <Route path='/formfillupbatchswitches' element={<FormfillupBatches
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          sessions={sessions}
                          />}> 
                 </Route> 

                 <Route path='/formfillupDetails' element={<FormFillupDetails
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                 </Route> 
                   <Route path='/submittedformfillupcsvreport' element={<SubmittedFormFillupReport
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                              sessions={sessions}
                          />}> 
                          
                 </Route> 
                  <Route path='/newregistrationcsv' element={<SubmittedNewRegistrationAndFormFillupReport
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                            sessions={sessions}
                          />}>                           
                 </Route> 
                       <Route path='/allowresubmission' element={<AllowResubmission
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                           sessions={[examSession]}
                          />}> 
                 </Route> 
                 <Route path='/attendancesheet' element={<AttendanceSheet
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                           sessions={sessions}
                          />}> 
                 </Route> 

                  <Route path='/studenttranscript' element={<StudentTranscript
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                 </Route> 
                 
                
                <Route path='/moreoptions' element={<MoreOptions
                          />}> 
                </Route>
                
                
            </Route>
         
        
            <Route  path='/about' element={<About></About>}></Route>
            <Route  path='/accessdenied' element={<AccessDenied></AccessDenied>}></Route>
            <Route path='*' element={<NotFound></NotFound>}></Route>

            <Route  path='/login' element={!isAuthenticated? <LoginUI
                  setRefreshFailed={setRefreshFailed} setGlobalLoginType={setLoginType} setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>:<Navigate to="/" />}>            
            </Route>
            <Route  path='/logout' element={isAuthenticated? <LogOutUI
            setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated} setLoginType={setLoginType} setRefreshFailed={setRefreshFailed}/>:<Navigate to="/Login" />}>            
            </Route>
          </Routes>
          </>
        }
      
      { (isAppLoaded) &&!refreshFailed &&(loginType.toLowerCase()==="student")&&
          <>
          <Routes>
             <Route element={<ProtectedRoute isAuthenticated={isAuthenticated}/>}>
                <Route  path='/' element={<HomeStudent userFullName={fullName}
                          />}>            
                </Route> 
                <Route  path='/viewresult/:session' element={<ViewMyResult 
                 accessToken={accessToken} 
                 setAccessToken={setAccessToken}
                 setRefreshFailed={setRefreshFailed}
                          />}>            
                </Route> 

                <Route  path='/doformfillup2026may' element={<DoFormFillup 
                 accessToken={accessToken} 
                 setAccessToken={setAccessToken}
                 setRefreshFailed={setRefreshFailed}
                 examsession={'2026-MAY'}
                          />}>            
                </Route> 
                 <Route  path='/doformfillup2025december' element={<DoFormFillup 
                 accessToken={accessToken} 
                 setAccessToken={setAccessToken}
                 setRefreshFailed={setRefreshFailed}
                 examsession={'2025-DECEMBER'}
                          />}>            
                </Route> 

                <Route  path='/admit2025december' element={<DownloadMyAdmitCard 
                 accessToken={accessToken} 
                 setAccessToken={setAccessToken}
                 setRefreshFailed={setRefreshFailed}
                  examsession={'2025-DECEMBER'}
                          />}>            
                </Route> 
                <Route  path='/admit2026may' element={<DownloadMyAdmitCard 
                 accessToken={accessToken} 
                 setAccessToken={setAccessToken}
                 setRefreshFailed={setRefreshFailed}
                  examsession={'2026-MAY'}
                          />}>            
                </Route> 
                
                         <Route  path='/applyconvocation' element={<ApplyConvocation 
                 accessToken={accessToken} 
                 setAccessToken={setAccessToken}
                 setRefreshFailed={setRefreshFailed}
                          />}>            
                </Route>      
                <Route path='/moreoptions' element={<MoreOptions
                          />}> 
                </Route>
               
            </Route>
         
        
            <Route  path='/about' element={<About></About>}></Route>
            <Route  path='/accessdenied' element={<AccessDenied></AccessDenied>}></Route>
            <Route path='*' element={<NotFound></NotFound>}></Route>

            <Route  path='/login' element={!isAuthenticated? <LoginUI
                  setGlobalLoginType={setLoginType} setRefreshFailed={setRefreshFailed}  setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>:<Navigate to="/" />}>            
            </Route>
            <Route  path='/logout' element={isAuthenticated? <LogOutUI
            setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated} setRefreshFailed={setRefreshFailed}/>:<Navigate to="/Login" />}>            
            </Route>
          </Routes>
          </>
        }
      
      { (isAppLoaded) &&!refreshFailed &&(loginType.toLowerCase()==="newstudent")&&
          <>
          
          <Routes>
             <Route element={<ProtectedRoute isAuthenticated={isAuthenticated}/>}>
                         
                <Route path='/moreoptions' element={<MoreOptions
                          />}> 
                </Route>
                
                <Route path='/newStudent' element={<NewStudent
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                refreshFailed={refreshFailed}
                setRefreshFailed={setRefreshFailed}
                          />}> 
                </Route>
            </Route>
         
        
            <Route  path='/about' element={<About></About>}></Route>
            <Route path='*' element={<NotFound></NotFound>}></Route>

            <Route  path='/login' element={!isAuthenticated? <LoginUI
                  setGlobalLoginType={setLoginType} setRefreshFailed={setRefreshFailed}  setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>:<Navigate to="/" />}>            
            </Route>
            <Route  path='/logout' element={isAuthenticated? <LogOutUI
            setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated} setRefreshFailed={setRefreshFailed}/>:<Navigate to="/Login" />}>            
            </Route>
          </Routes>
          </>
        }

      {
        !isAppLoaded &&
          <div className='spinnerovsetSeerlay'>
            <div className='spinnerbody'>
              <Spinner animation="border" variant="info" />
              <p>Please wait. It might take a few seconds.</p>
            </div>           
          </div>
      }
      {
       (isAppLoaded) && refreshFailed && 
        <>
        <Routes>
        <Route  path='/about' element={<About></About>}></Route>
        <Route  path='/accessdenied' element={<AccessDenied></AccessDenied>}></Route>
          <Route path='*' element={ <LoginUI
                setGlobalLoginType={setLoginType} setRefreshFailed={setRefreshFailed} setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>}>            
                </Route>

          <Route  path='/login' element={ <LoginUI
                setGlobalLoginType={setLoginType} setRefreshFailed={setRefreshFailed}   setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>}>            
          </Route>
          <Route  path='/logout' element={ <LogOutUI
          setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated} setRefreshFailed={setRefreshFailed}/>}>            
          </Route>
          
        </Routes>
        </>
      }

        <Footer></Footer>
      </div>
    </Router>
  );
}

export default App;
